export default "// Fragment shader for vector field arrows\n\nvoid main() {\n    // Color: #D2B14C\n    gl_FragColor = vec4(0.824, 0.694, 0.298, 1.0);\n}\n";